import { render, staticRenderFns } from "./DrinkerResultsMonthly.vue?vue&type=template&id=56e39cd0&scoped=true&"
import script from "./DrinkerResultsMonthly.vue?vue&type=script&lang=ts&"
export * from "./DrinkerResultsMonthly.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56e39cd0",
  null
  
)

export default component.exports